<script setup>
import ChevronDownIcon from '@/components/icon/ChevronDownIcon.vue'
import { getCurrentInstance, ref, useSlots } from 'vue'
const { emit } = getCurrentInstance()

const slots = useSlots()
const props = defineProps({
  collapseKey: {
    type: [String, Number],
    required: true
  },
  headerClicked: {
    type: Boolean,
    default: false
  },
  returnCollapsedKey: {
    type: Boolean,
    default: false,
    required: false
  }
})
const show = ref(false)

const onShow = () => {
  show.value = !show.value
  if (props.returnCollapsedKey && show.value) {
    emit('collapseKeyClicked', props.collapseKey)
  }
}
</script>

<template>
  <div class="mf-collapse">
    <template v-if="headerClicked">
      <div class="mf-collapse-header cursor-pointer" @click="onShow">
        <template v-if="slots.collapseHeader">
          <slot :name="'collapseHeader'" :show="show" />
        </template>
        <button :class="show && 'show'" type="button">
          <ChevronDownIcon />
        </button>
      </div>
    </template>
    <template v-else>
      <div class="mf-collapse-header cursor-pointer" @click="onShow">
        <template v-if="slots.collapseHeader">
          <slot :name="'collapseHeader'" :show="show" />
        </template>
        <button @click="onShow" :class="show && 'show'" type="button">
          <ChevronDownIcon />
        </button>
      </div>
    </template>
    <template v-if="show">
      <div class="mf-collapse-body" :class="show && 'show'">
        <slot :name="'collapseBody'" />
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}

.mf-collapse {
  background-color: #ffffff;
  border: 1px solid #f5f5f5;

  &-header {
    display: flex;
    justify-content: space-between;
    padding: 1.8rem;

    button {
      border: none;
      cursor: pointer;
      background-color: #ffffff;

      svg {
        transition: all 0.25s;
      }

      &.show {
        svg {
          transition: all 0.25s;
          transform: rotate(180deg);
        }
      }
    }
  }

  &-body {
    overflow: hidden;
    opacity: 0;
    padding-left: 40px;
    padding-right: 40px;
    animation: show 0.5s linear forwards;
    padding-bottom: 1rem;
    transform: translateY(-20px);
  }

  @keyframes show {
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
